import useSWRMutation from "swr/mutation";
import { useAccountId } from "../../../../auth/useAccountId";
import { CORE_API_HOSTNAME } from "../../../../env";
import fulfill from "../../../../fulfill";
import type { Grant } from "../../../../types/management-auth";
import { useClient } from "../../clientDetails/hooks/useClient";

const fetchCreateGrant = async (
    _key: string,
    options: {
        arg: {
            accountId: string;
            clientId: string;
            grant: Grant;
        };
    },
): Promise<Grant> => {
    const audience = options.arg.grant.audience;
    const account = audience.split("/").pop();
    const result: Grant = await fulfill.post({
        accountId: account || "",
        url: `${CORE_API_HOSTNAME}/v1/accounts/${account}/auth/client-grants`,
        json: options.arg.grant,
        handlers: {
            200: (grant: Grant) => grant,
        },
    });
    return result;
};

export const useNewClientGrant = (clientId: string) => {
    const accountId = useAccountId();
    const client = useClient(clientId);
    const newGrantMutation = useSWRMutation(
        `${accountId}/clients/${clientId}/grants`,
        fetchCreateGrant,
    );

    const createGrant = async (
        accountId: string,
        clientId: string,
        grant: Grant,
    ) => {
        await newGrantMutation.trigger({
            accountId,
            clientId,
            grant,
        });
    };

    return {
        client: client.client,
        grants: client.grants,
        isCreated: !!newGrantMutation.data,
        isLoading: newGrantMutation.isMutating || client.isLoading,
        createGrant,
    };
};
